export default __webpack_public_path__ + "static/media/bookingimg.ed18f133.png";